import request from '../utils/RequestUtil';

async function refreshToken() {
  return request({
    url: '/token/refresh',
    method: 'POST'
  });
}

function revokeToken() {
  return request({
    url: '/token/revoke',
    method: 'POST'
  });
}



// eslint-disable-next-line import/prefer-default-export
export { refreshToken, revokeToken };
